/**
 * "ข้อควรระวัง / กรณีที่มักถูกตีกลับ" block.
 * Page-specific rejection causes; no guarantees, no pricing, no review markup.
 */

export function ServiceCautionBlock({
  items,
  locale = "th",
  title,
}: {
  items: string[];
  locale?: "th" | "en";
  title?: string;
}) {
  if (!items.length) return null;
  const heading =
    title ?? (locale === "th" ? "ข้อควรระวังและกรณีที่มักถูกตีกลับ" : "Cautions and common rejection causes");
  return (
    <section aria-label={heading} className="mt-8 rounded-lg border border-destructive/30 bg-destructive/5 p-5">
      <h2 className="mb-3 text-xl font-bold">{heading}</h2>
      <ul className="list-disc space-y-2 pl-5 text-sm leading-relaxed text-muted-foreground">
        {items.map((t, i) => (
          <li key={i}>{t}</li>
        ))}
      </ul>
      <p className="mt-3 text-xs text-muted-foreground">
        {locale === "th"
          ? "เราตรวจเอกสารก่อนยื่นเพื่อลดโอกาสถูกตีกลับ แต่การอนุมัติเป็นอำนาจของหน่วยงานปลายทางเท่านั้น"
          : "We pre-check files to reduce the chance of rejection; the receiving authority alone decides acceptance."}
      </p>
    </section>
  );
}